const subheadingsData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
          <p>Hello World!</p>
          <p>
            My name is Lomia Wu. I am passionate about creating user-friendly
            applications that are both functional and aesthetically pleasing.
          </p>
          <p>I am seeking a full-time position as a developer now.</p>
        </>
      ),
    },
  ],
  2: [
    {
      title: "2024 Advanced Diploma",
      content: (
        <>
          <p>
            I'm currently studying at Seneca Polytechnic in the Computer
            Programming and Analysis program.
          </p>
          <p> My expected graduation date is July 2024.</p>
        </>
      ),
    },
  ],
  3: [
    {
      title: "2023 Fullstack Developer",
      content: (
        <>
          <p>
            I was a co-op fullstack developer at a startup company called Mydoh,
            which is powered by RBC Ventures. My daily tasks included building a
            mobile app using React Native and TypeScript and integrating the backend using Node.js.
          </p>
        </>
      ),
    },
    {
      title: "2023 Web Developer",
      content: (
        <>
          <p>
            I was a co-op developer at RBC T&O. My job was implmenting web
            applications, debugging and testing code, investigating and fixing
            issues, collaborating with seniors.
          </p>
        </>
      ),
    },
  ],
};

export default subheadingsData;
